module.exports = __webpack_public_path__ + "img/Tessellate02.8594d0c6.jpg";